<app-resizable-modal-component [dragHolder]="header">
    <div #header class="d-flex flex-column h-100">
        <div class="modal-header  p-3 py-1 pb-2">
            <div class="titleName gap-2">
                <img class="avatar-sm rounded-circle img-thumbnail " src="/assets/images/ai/myfile-chat-icon.png">
                <div>
                    <h5 class="modal-title" id="exampleModalLabel" i18n="@@">MyFile AI Assistant </h5>
                    <span class="text-muted">(Preview)</span>
                </div>
            </div>

            <div class="titleName">
                <div ngbDropdown>
                    <span class="btn btn-icon" style="color: #8d8e90 !important;" type="button"
                        data-bs-toggle="dropdown" ngbDropdownToggle>
                        <i class="ri-more-2-fill me-1 align-middle fs-20"></i>
                    </span>
                    <ul class="dropdown-menu regular" ngbDropdownMenu>
                        <span>
                            <!-- <li class="p-2">
                                <a class="highlight" routerLink="{{routerLinkLearnMore}}">
                                    Learn more
                                </a>
                            </li> -->
                            <li class="p-2">
                                <a class="highlight cursor-pointer" (click)="clearChat(false)">
                                    New Chat
                                </a>
                            </li>
                            <li class="p-2">
                                <a class="highlight" routerLink="{{routerLinkTerms}}">
                                    Terms of Use
                                </a>
                            </li>
                            <li class="p-2">
                                <a class="highlight" routerLink="{{routerLinkPrivacy}}">
                                    Privacy Policy
                                </a>
                            </li>

                        </span>
                    </ul>
                </div>
                <button type="button" class="btn-close" data-bs-dismiss="modal" id="close-modal"
                    (click)="close()"></button>
            </div>
        </div>

        <div *ngIf="showVideo" class="card-body p-0 videoOverlay" (animationend)="showVideo = false"
            [ngClass]="{ 'heightTransformAnimation': animateOut === true }"
            style="padding-bottom: 0.84rem !important; ">
            <video class="video" width="500" muted=true autoplay="true" (pause)="triggerAnimation();"
                (ended)="triggerAnimation()" #videoPlayer>
                <source src="/assets/images/marketplace/short-video.webm" type="video/webm">
            </video>
        </div>

        <div class="card-body p-0 border-top border-top-dashed" style="padding-bottom: 0.94rem !important; ">
            <div id="users-chat">
                <ngx-simplebar #chatBox class="chat-conversation p-3 overflow-auto" id="chat-conversation"
                    data-simplebar>
                    <div class="card-body mx-1 no-flex">
                        <div *ngIf="modalEntityId  else elseDefault" class="d-flex gap-2">
                            <div>
                                <i class="ri-information-line"></i>Discover instant insights with our innovative AI
                                Document Insights Analysis Tool,
                                powered by MyFile AI Assistant. Simply ask questions about your document, and the MyFile
                                AI Assistant will rapidly analyze it, providing you with actionable and accurate
                                answers. The AI Assistant can also generate answers in different formats such as
                                csv.<br />
                                <a class="highlight" routerLink="{{routerLinkLearnMore}}">Learn More</a>
                            </div>
                        </div>
                        <ng-template class="d-flex gap-2" #elseDefault>
                            <div> <app-custom-tool-tips [contentText]="''" [link]="'/pages/how-to-center?section=insights'" [linkText]="'Learn More'"></app-custom-tool-tips> 
                                Hello I'm the MyFile AI Assistant. How can I
                                help you today?</div><br />
                            <ng-template #hintTooltip>
                                Sample hint description
                                <a href="www.abc.com" target="_blank"
                                    >Learn more</a>
                            </ng-template>
                        </ng-template>

                        <div *ngIf="!suggestionsHidden" class="d-flex ">
                            <div>
                                Select one of the categories to get started.
                            </div>
                        </div>
                    </div>
                    <span *ngIf="!suggestionsHidden">
                        <div class="card-body  no-flex">
                            <div class="my-2 pb-0 rounded hint-hover-effect ">
                                <a (click)="presetMessages(messageTypeEnum.HowTo)">
                                    <div class="border p-2 rounded d-flex justify-content-between "
                                        [ngClass]="{ 'selectedSuggestion': selectedMessageType === messageTypeEnum.HowTo, 'cursor-pointer': loadingResponse === false, 'cursor-default': loadingResponse === true }"
                                        style="background-color: var(--vz-light);">
                                        <span>
                                            How It Works
                                        </span>
                                        <div>
                                            <i class="ri-external-link-line"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="card-body  no-flex">
                            <div class="my-2  pb-0 rounded hint-hover-effect ">
                                <a (click)="presetMessages(messageTypeEnum.Faq)">
                                    <div class="border p-2 rounded d-flex justify-content-between "
                                        [ngClass]="{ 'selectedSuggestion': selectedMessageType === messageTypeEnum.Faq,'cursor-pointer': loadingResponse === false, 'cursor-default': loadingResponse === true }"
                                        style="background-color: var(--vz-light);">
                                        <span>
                                            Frequently Asked Questions
                                        </span>
                                        <div>
                                            <i class="ri-external-link-line"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="card-body no-flex">
                            <div class="my-2 pb-0 rounded hint-hover-effect ">
                                <a (click)="presetMessages(messageTypeEnum.ReleaseNotes)">
                                    <div class="border p-2 rounded d-flex justify-content-between "
                                        [ngClass]="{ 'selectedSuggestion': selectedMessageType === messageTypeEnum.ReleaseNotes,'cursor-pointer': loadingResponse === false, 'cursor-default': loadingResponse === true}"
                                        style="background-color: var(--vz-light);">
                                        <span>
                                            What's New
                                        </span>
                                        <div>
                                            <i class="ri-external-link-line"></i>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </span>
                    <div *ngIf="suggestionsModel !== undefined && suggestionsModel.length >= 0"
                        class="card-body mx-1 mt-2 no-flex border-top border-top-dashed">
                        <div class="d-flex gap-2 pt-2">
                            <h6 class="text-muted">
                                <i class="ri-flashlight-line"></i>
                                Suggestions
                            </h6>
                        </div>
                        <div>
                            <ul class="list-unstyled">
                                <div *ngFor="let message of suggestionsModel; let index = index"
                                    class="suggestion-hover-effect "
                                    [ngClass]="{ 'cursor-pointer': loadingResponse === false, 'cursor-default': loadingResponse === true }"
                                    (click)="askSuggestion(message.title)">
                                    <div class="p-2 rounded">
                                        {{message.title}}
                                        <div class="text-muted">
                                            {{message.subtext}}
                                        </div>
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>
                    <ul class="list-unstyled chat-conversation-list chat-sm" id="users-conversation">
                        <li *ngFor="let message of messageHistory; let index = index"
                            [ngClass]="{ 'left': message.messageType === EnumAIChat.Response, 'right': message.messageType === EnumAIChat.Question }"
                            class="chat-list ">
                            <div class="conversation-list">
                                <div class="user-chat-content">

                                    <div class="d-flex"
                                        [ngClass]="{ 'left': message.messageType === EnumAIChat.Response, 'right': message.messageType === EnumAIChat.Question }">
                                        <img *ngIf="message.messageType === EnumAIChat.Response"
                                            class="avatar-xs rounded-circle me-2"
                                            src="/assets/images/ai/myfile-chat-icon.png">

                                        <div>
                                            <div class="conversation-name">

                                                <div *ngIf="(message.messageType === EnumAIChat.Response)"
                                                    class="modal-title" style="font-size: small;" id="exampleModalLabel"
                                                    i18n="@@">
                                                    MyFile AI Assistant
                                                </div>
                                                <small class="text-muted time">{{message.time
                                                    |
                                                    date:
                                                    'h:mm
                                                    a'}}</small>

                                            </div>

                                            <div class="ctext-wrap">

                                                <div *ngIf='(message.message && message.message.length > 0)'
                                                    class="ctext-wrap-content ">

                                                    <pre class="mb-0 ctext-content preWrap fonts">
                                                            {{message.message}}
                                                        </pre>

                                                </div>
                                                <div *ngIf='loadingResponse && (message.message === undefined || message.message.length === 0)'
                                                    class="blobs ctext-wrap-content lightTheme darkTheme">
                                                    <div class="app-loader" [ngClass]="{'dark': (color === 'dark')}">
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="conversation-name">
                                                <span
                                                    *ngIf="(message.messageType === EnumAIChat.Response) && (!message.disableLikeButtons)"
                                                    class="cursor-pointer gap-2 d-flex">
                                                    <span class="cursor-pointer ri-clipboard-line"
                                                        (click)="copyMessage(message.message)"
                                                        ngbTooltip="Copy to Clipboard">
                                                    </span>
                                                    <span (click)="likeMessage(message, false)"
                                                        ngbTooltip="Bad Response"
                                                        [ngClass]="(message.liked === false)?'ri-thumb-down-fill':'ri-thumb-down-line'"></span>

                                                    <span (click)="likeMessage(message, true)"
                                                        ngbTooltip="Good Response"
                                                        [ngClass]="(message.liked)?'ri-thumb-up-fill':'ri-thumb-up-line'"></span>
                                                </span>

                                                <button
                                                    *ngIf='loadingResponse && ((index) === (messageHistory.length-1)) && (message.messageType === EnumAIChat.Response)'
                                                    (click)="cancelRequest()" type="submit"
                                                    class="btn btn-soft-primary"><i class="mdi mdi-cancel"></i>
                                                    Cancel Request</button>
                                            </div>

                                        </div>


                                    </div>

                                </div>
                            </div>
                        </li>


                    </ul>

                </ngx-simplebar>

            </div>

            <div class="border-top border-top-dashed">
                <div class="row g-2 mx-3 mt-2">
                    <div class="col">
                        <div class="position-relative">
                            <textarea [disabled]='loadingResponse' [(ngModel)]="userInputMessage" type="text" style="max-height: 54px !important; overflow-y: auto;
                word-wrap:break-word" (keyup.enter)="addUserMessageAsync()" class="form-control border-light bg-light"
                                placeholder="Enter a message"></textarea>
                        </div>
                    </div>

                    <div class="col-auto">
                        <button style="height: -webkit-fill-available !important;" [disabled]='loadingResponse'
                            (click)="addUserMessageAsync()" type="submit" class="btn btn-info"><i
                                class="mdi mdi-send"></i></button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</app-resizable-modal-component>